import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames'


export default class ColumnHeading extends React.Component {

  render () {

    const {column} = this.props
    const noTitle = (!column.title || !column.title.trim())

    const classes = classnames(
      'column-heading',
      {'is-not-printed': !column.printed},
      {'column-heading-no-title': noTitle},
    )

    let lines = column.title.split("\n")
    while (lines.length < 3) lines.unshift('')

    return (
      <div>
        <div className={classes}>
          {
            noTitle
            ? 'No Title'
            : lines.map((line, i) => line ? <div key={i}>{line}</div> : null)
          }
        </div>
        <div className="left-padding"></div>
        <div className="right-padding"></div>
      </div>
    )
  }
}


ColumnHeading.propTypes = {
  column: PropTypes.object.isRequired,
}
